import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from "react-beautiful-dnd";
import FloatingLabelTextInput from "../../../../../../common-components/floatingtextinput";
import MultipleSelect from "../../../../../../common-components/multipleSelect";
import { ISubTasksDetails } from "../../../../../../models/freshman/configuration";
import { useEffect, useState } from "react";
import { IDropdownData } from "../../../../../../models/ICommon";
import MultipleInactiveSelect from "../../../../../../common-components/multipleInactiveSelect";

const FreshmanConfigurationSubTask = (props: ISubTasksDetails) => {
  const {
    subTaskData,
    setSubTaskData,
    selectedMainStep,
    mainTaskData,
    subSteps,
    allSubSteps,
  } = props;

  const isValidURL = (url: string) => {
    if (url.length === 0) {
      return true;
    }
    const urlRegex = /^(https?:\/\/)?([\w\-]+(\.[\w\-]+)+)(\/[\w\-./?%&=]*)?$/;
    return urlRegex.test(url);
  };

  const [subStepData, setSubStepData] = useState<IDropdownData[]>([])

  useEffect(() => {
    const activeDropdownData: IDropdownData[] = subSteps
      .filter((data) => data.isActive === true)
      .map((data) => ({
        id: data.id,
        name: data.name,
        isActive: data.isActive
      }));
    const inactiveDropdownData: IDropdownData[] = subTaskData.subTask
      .map((data) => ({
        id: data.id,
        name: data.name,
        isActive: subSteps.find((subStep) => subStep.id == data.id)?.isActive
      }));

    const uniqueSteps = new Map(
      [...activeDropdownData, ...inactiveDropdownData].map(item => [item.id, item])
    );

    setSubStepData(Array.from(uniqueSteps.values()));
    console.log("substep", subStepData);

  }, [subSteps, subTaskData]);

  const onSubChange = (event: any, stepid?: number) => {
    if (event.target.name === "subSteps") {
      const _subTasks = Array.from(event.target.value);
      const afterRemove =
        subTaskData.subTask?.filter(
          (ss) => ss.mainStepId !== selectedMainStep
        ) || [];

      const newTask = _subTasks.map((st: any, index: number) => ({
        mainStepId: selectedMainStep,
        id: st,
        order: index + 1,
        prerequisites: [],
        name: subSteps?.find((ss) => ss.id == st)?.name || "",
        url: allSubSteps?.find((u: any) => u.id === st)?.url || "",
      }));

      const updatedSubTasks = [...afterRemove, ...newTask];
      setSubTaskData({ ...subTaskData, subTask: updatedSubTasks });
    } else if (event.target.name === "url") {
      const stepIndex = subTaskData.subTask?.findIndex(
        (st) => st.mainStepId === selectedMainStep && st.id === stepid
      );
      let task = [...subTaskData.subTask];
      const isValid = isValidURL(event.target.value);
      task[stepIndex] = {
        ...task[stepIndex],
        url: event.target.value,
        errors: isValid ? "" : "Invalid URL",
      };
      setSubTaskData({ ...subTaskData, subTask: task });
    } else if (event.target.name === "subStepPredecessor") {
      const stepIndex = subTaskData.subTask?.findIndex(
        (st) => st.mainStepId === selectedMainStep && st.id === stepid
      );
      let task = subTaskData.subTask;
      task[stepIndex] = {
        ...task[stepIndex],
        prerequisites: event.target.value,
      };
      setSubTaskData({ ...subTaskData, subTask: task });
    }
  };

  const handleOnDragEndSub = (result: DropResult) => {
    const { destination, source } = result;
    if (!destination) return;
    let _allSubTasks = subTaskData.subTask;
    let nonUpdatedSubTask = _allSubTasks.filter(
      (as) => as.mainStepId !== selectedMainStep
    );
    let updatedSubTask = _allSubTasks?.filter(
      (ust) => ust.mainStepId === selectedMainStep
    );
    const [movedItem] = updatedSubTask?.splice(source.index, 1);
    updatedSubTask?.splice(destination.index, 0, movedItem);

    const updatedOrder = updatedSubTask?.map((us, index) => ({
      ...us,
      order: index + 1,
      prerequisites: [],
    }));

    const updatedAllTask = [...nonUpdatedSubTask, ...updatedOrder];
    setSubTaskData({ ...subTaskData, subTask: updatedAllTask });
  };

  const removeSubStep = (subStepId: number) => {
    const currentOrder =
      subTaskData.subTask?.find((ss) => ss.id === subStepId)?.order ?? Infinity;
    const relatedItems = subTaskData.subTask
      ?.filter(
        (ss) => ss.mainStepId === selectedMainStep && ss.id !== subStepId
      )
      .map((task) => {
        return {
          ...task,
          order:
            (task?.order ?? 0) < currentOrder
              ? task.order
              : (task?.order ?? Infinity) - 1,
          prerequisites: task?.prerequisites?.filter(
            (pre) => pre !== subStepId
          ),
        };
      });
    const remainingItems = subTaskData.subTask?.filter(
      (ss) => ss.mainStepId !== selectedMainStep
    );
    const updatedSubTask = [...remainingItems, ...relatedItems];
    setSubTaskData({ ...subTaskData, subTask: updatedSubTask });
  };

  return (
    <>
      <div className="leftwrap subtask-content">
        <div className="titlewrap">
          <h6>Sub Task List</h6>
          <div className="w-100">
            <div className="w-100 dd-freshman-config">
              {/* <MultipleSelect
                label={""}
                onChange={onSubChange}
                isMandatory={false}
                values={
                  (subTaskData.subTask
                    ?.filter((ss) => ss.mainStepId === selectedMainStep)
                    .map((item) => item.id)
                    .filter((id) => id !== null) as number[]) || []
                }
                name={"subSteps"}
                optionList={subStepData}
                placeholder={"Select Sub Tasks"}
                disabled={
                  mainTaskData.mainTask.length > 0 && selectedMainStep > 0
                    ? false
                    : true
                }
              /> */}
              <MultipleInactiveSelect
                label={""}
                onChange={onSubChange}
                isMandatory={false}
                values={
                  (subTaskData.subTask
                    ?.filter((ss) => ss.mainStepId === selectedMainStep)
                    .map((item) => item.id)
                    .filter((id) => id !== null) as number[]) || []
                }
                name={"subSteps"}
                optionList={subStepData}
                disabled={
                  mainTaskData.mainTask.length > 0 && selectedMainStep > 0
                    ? false
                    : true}
                placeholder={"Select Sub Tasks"}
              />
            </div>
          </div>
        </div>
        <div>
          <DragDropContext onDragEnd={handleOnDragEndSub}>
            <Droppable droppableId="subStepId">
              {(provided: any) => (
                <ul ref={provided.innerRef} {...provided.droppableProps}>
                  {subTaskData.subTask
                    ?.filter((ss) => ss.mainStepId == selectedMainStep)
                    .map((step, index) => (
                      <Draggable
                        key={step.id}
                        draggableId={step.id?.toString() || index.toString()}
                        index={index}
                      >
                        {(provided: any) => (
                          <li
                            key={step.id}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <div
                              className="numbered"
                              {...provided.dragHandleProps}
                            >
                              <img src="/assets/images/drag.svg" alt="" />
                            </div>
                            <div className="title">
                              <p>{step.name}</p>
                              <div className="form-group w-100 mt-2">
                                {step.order && step.order > 1 && (
                                  <MultipleSelect
                                    label={""}
                                    onChange={(event: any) =>
                                      onSubChange(event, step.id ?? undefined)
                                    }
                                    isMandatory={false}
                                    values={
                                      subTaskData.subTask
                                        ?.filter(
                                          (st) =>
                                            st.mainStepId === selectedMainStep
                                        )
                                        ?.find(
                                          (pre) => pre.id && pre.id == step.id
                                        )?.prerequisites || []
                                    }
                                    name={"subStepPredecessor"}
                                    optionList={subTaskData.subTask.filter(
                                      (st) => {
                                        const stOrder = st.order ?? Infinity;
                                        const stepOrder =
                                          step.order ?? Infinity;
                                        return (
                                          st.mainStepId === selectedMainStep &&
                                          stOrder < stepOrder
                                        );
                                      }
                                    )}
                                    placeholder={"Select Predecessor"}
                                  />
                                )}
                                {
                                  <FloatingLabelTextInput
                                    label={""}
                                    onChange={(event: any) =>
                                      onSubChange(event, step.id ?? undefined)
                                    }
                                    isMandatory={true}
                                    value={
                                      subTaskData.subTask?.find(
                                        (st) =>
                                          st.mainStepId == selectedMainStep &&
                                          st.id == step.id
                                      )?.url
                                    }
                                    name={"url"}
                                    maxLength={50}
                                    placeholder={"Enter Url"}
                                  />
                                }
                                {subTaskData.subTask?.find(
                                  (st) =>
                                    st.mainStepId == selectedMainStep &&
                                    st.id == step.id
                                )?.errors && (
                                    <div className="text-danger">
                                      {
                                        subTaskData.subTask?.find(
                                          (st) =>
                                            st.mainStepId == selectedMainStep &&
                                            st.id == step.id
                                        )?.errors
                                      }
                                    </div>
                                  )}
                              </div>
                            </div>
                            <div className="form-checkbox">
                              <button
                                className="btn-close"
                                onClick={() => removeSubStep(step.id ?? 0)}
                              ></button>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
    </>
  );
};

export default FreshmanConfigurationSubTask;
